import __request__ from "routing/request";
export function simulate(simulation, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/illuminate/simulate", simulation, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
